import { Name } from '../models.common';
export function sortByName(a: Name, b: Name): number {
  return (
    (a?.last ?? '').localeCompare(b?.last ?? '') || (a?.first ?? '').localeCompare(b?.first ?? '')
  );
}
